<script>
import IconHistory from '@img/icons/material-duotone/history.svg?inline';
import IconContract from '@img/icons/material-duotone/data-object.svg?inline';
import IconNft from '@img/icons/material-duotone/view-in-ar.svg?inline';
import IconToken from '@img/icons/material-duotone/toll.svg?inline';
import IconWhitelist from '@img/icons/material-duotone/groups.svg?inline';
import IconActions from '@img/icons/material-duotone/list.svg?inline';

import UiTabs from '~/components/UiTabs.vue';
import TabUserNfts from '~/components/address/TabUserNfts.vue';
import TabUserTokens from '~/components/address/TabUserTokens.vue';
import TabContractSources from '~/components/address/Verifier/Verifier.vue';
import TxRoot from '~/components/address/TxRoot.vue';
import TabOrderSigners from './TabOrderSigners.vue';
import TabOrderActions from './TabOrderActions.vue';

export default {
    props: {
        isActive: Boolean,
        address: {
            type: String,
            required: true,
        },
        whitelist: Array,
        signers: Array,
        isLoading: Boolean,
        approvalsMask: String,
        actions: Array,
    },

    render(createComponent) {
        return createComponent(UiTabs, {
            class: 'card card--tabbed',
            props: {
                tabs: this.tabs,
                changeUrlHash: true,
            },
            on: this.$listeners, // passthru listeners from parent
            scopedSlots: this.$scopedSlots,
        });
    },

    computed: {
        tabs() {
            const props = { address: this.address };
            const key = this.address; // keepalive key

            return [{
                key: 'events',
                text: this.$t('address.tab_events'),
                icon: IconHistory,
                content: {
                    key, props,
                    eager: true,
                    component: TxRoot,
                },
            }, {
                key: 'signers',
                text: this.$t('multisig.signers'),
                icon: IconWhitelist,
                content: { key, props: {
                    addressList: this.signers,
                    isLoading: this.isLoading,
                    approvalsMask: this.approvalsMask,
                },
                component: TabOrderSigners,
                },
            }, {
                key: 'order',
                text: this.$t('multisig.actions'),
                icon: IconActions,
                content: { key, props: {
                    actions: this.actions,
                },
                component: TabOrderActions,
                },
            }, {
                key: 'tokens',
                text: this.$t('address.tab_tokens'),
                icon: IconToken,
                content: { key, props, component: TabUserTokens },
            }, {
                key: 'nfts',
                text: this.$t('address.tab_nfts'),
                icon: IconNft,
                content: { key, props, component: TabUserNfts },
            }, {
                key: 'source',
                text: this.$t('address.tab_contract'),
                icon: IconContract,
                content: {
                    key,
                    component: TabContractSources,
                    props: {
                        address: this.address,
                        isActive: this.isActive,
                    },
                },
            }];
        },
    },
    components: {
        UiTabs,
        TxRoot,
    },
};
</script>
